/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryResourceDetailsRequest {
    getFixupPrototypeFunction() { return InventoryResourceDetailsRequest.fixupPrototype; }

    static newInstance(model: Partial<InventoryResourceDetailsRequest>): InventoryResourceDetailsRequest {
        let obj = Object.assign(new InventoryResourceDetailsRequest(), model);
        InventoryResourceDetailsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryResourceDetailsRequest>): InventoryResourceDetailsRequest {
        if (!model) return null;
        return InventoryResourceDetailsRequest.newInstance(<InventoryResourceDetailsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryResourceDetailsRequest) {
        if (!obj) return;

        models.InventoryResourceDetailsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryResourceDetailsRequest): boolean {
        Object.setPrototypeOf(obj, InventoryResourceDetailsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.InventoryResourceDetailsDataModel.fixupPrototype(this.filters);
        }
    }

    /**
     * Filter resource details
     */
    filters: models.InventoryResourceDetailsDataModel;

}
